// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1cf35644","96":"1eb00625","208":"f8592faa","214":"35274212","289":"f8fc69f9","617":"d2294432","733":"f75576aa","734":"48734669","945":"899e8f5f","974":"f456ea73"}[chunkId] + ".chunk.js";
};